// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const companies = {
  id: "companies",
  title: "Companies",
  type: "group",
  children: [
    {
      id: "companies",
      title: "Companies",
      type: "item",
      url: "/companies",
    },
  ],
};

export default companies;
